
import * as vooglamRuntime$ztwFGeTLxd from '/src/providers/vooglam.js'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vooglam",
  "domains": [
    "cdn.vooglam.com",
    "cdn-test-vooglam.xmslol.cn",
    "common.xmslol.com"
  ],
  "alias": {},
  "densities": [
    1,
    2,
    3,
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['vooglam']: { provider: vooglamRuntime$ztwFGeTLxd, defaults: {"baseURL":"https://cdn-test-vooglam.xmslol.cn"} }
}
        